module.exports = {
      id: "minus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#minus",
      toString: function () {
        return this.url;
      }
    }